var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49029 4.5C8.15241 4.5 8.78742 4.76339 9.25561 5.23223C9.7238 5.70107 9.98682 6.33696 9.98682 7C9.98682 7.3283 9.92225 7.65339 9.79679 7.95671C9.67132 8.26002 9.48743 8.53562 9.25561 8.76777C9.02378 8.99991 8.74857 9.18406 8.44567 9.3097C8.14278 9.43534 7.81814 9.5 7.49029 9.5C6.82817 9.5 6.19317 9.23661 5.72498 8.76777C5.25679 8.29893 4.99376 7.66304 4.99376 7C4.99376 6.33696 5.25679 5.70107 5.72498 5.23223C6.19317 4.76339 6.82817 4.5 7.49029 4.5ZM7.49029 0C9.34423 0 11.1222 0.737498 12.4332 2.05025C13.7441 3.36301 14.4806 5.14348 14.4806 7C14.4806 12.25 7.49029 20 7.49029 20C7.49029 20 0.5 12.25 0.5 7C0.5 5.14348 1.23647 3.36301 2.54741 2.05025C3.85834 0.737498 5.63635 0 7.49029 0ZM7.49029 2C6.16605 2 4.89604 2.52678 3.95966 3.46447C3.02328 4.40215 2.49723 5.67392 2.49723 7C2.49723 8 2.49723 10 7.49029 16.71C12.4834 10 12.4834 8 12.4834 7C12.4834 5.67392 11.9573 4.40215 11.0209 3.46447C10.0845 2.52678 8.81454 2 7.49029 2Z",
    fill: "#85C4BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).1a3aba8af8ab5082dc3a99606df52419.svg";
export { ForwardRef as ReactComponent };